import axios from "axios";

export default axios.create({
    baseURL: "https://tnfserver.com/backend/api/",
    headers: {
        "Content-type": "application/json"

    }
});